const data = {
    "status" : "A digital Assistant",
    "bot-name" : "Query Bot",
    "Home": {
        "msg" : ["Hi, 😊 I am QueryBot at your service. Please select an option to help me serve you better:"],
        "utterance" : "Hi, I am QueryBot at your service. Please select an option to help me serve you better.",
        "type" : "button",
        "option" : [
            { "btn" : "My policy information", "isLink" : false, "keyword" : "I have a policy" },
            { "btn" : "NRI services", "isLink" : false, "keyword" : "I am NRI customer" },
            { "btn" : "Buy a policy", "isLink" : false, "keyword" : "I want to buy a policy" },
            { "btn" : "Death/Health claim", "isLink" : false, "keyword" : "Death and Health claim" },
            { "btn" : "I have a query", "isLink" : false,"keyword" : "I have a query" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "I have a policy": {
        "msg" : ["What you want to know about your policy? Below are some options that you can check."],
        "utterance" : "What you want to know about your policy? Below are some options that you can check.",
        "type" : "button",
        "option" : [
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Profile info", "isLink" : false, "keyword" : "Profile details" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Invest fund", "isLink" : false, "keyword" : "Invest fund" },
            { "btn" : "Fund value", "isLink" : false, "keyword" : "Fund value" },
            { "btn" : "Pan update", "isLink" : false, "keyword" : "Pan update" },
            { "btn" : "Set SI", "isLink" : false, "keyword" : "Set SI" },
            { "btn" : "medical_report_response", "isLink" : false, "keyword" : "medical_report_response" },
            { "btn" : "Home", "isLink" : false, "keyword" : "Home" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "I am NRI customer": {
        "msg" : ["Surely! I can help you with the below mentioned NRI services"],
        "utterance" : "Surely! I can help you with the below mentioned NRI services",
        "type" : "button",
        "option" : [
            { "btn" : "DTAA (Double Tax Avoidance Agreement)", "isLink" : false,"keyword" : "DTAA" },
            { "btn" : "TRC (Tax Residency Certificate)", "isLink" : false,"keyword" : "TRC" },
            { "btn" : "EVC (Existence Verification Check)", "isLink" : false,"keyword" : "EVC" },
            { "btn" : "Form 10F", "isLink" : false,"keyword" : "From 10F" },
            { "btn" : "<a class='bot-options-link-btn' href='https://www.google.com' target='_blank'>NRI GST refund</a>", "isLink" : true, },
            { "btn" : "More servicing options", "isLink" : false,"keyword" : "More servicing options" },
            { "btn" : "Home", "isLink" : false, "keyword" : "Home"  },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "I want to buy a policy": {
        "msg" : ["I can help you with"],
        "utterance" : "I can help you with",
        "type" : "button",
        "option" : [
            { "btn" : "Buy a new policy", "isLink" : false,  "keyword" : "Buy a new policy"  },
            { "btn" : "Track new application", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Document upload", "isLink" : false, "keyword" : "Document upload" },
            { "btn" : "Download mobile app", "isLink" : false, "keyword" : "Download mobile app" },
            { "btn" : "Home", "isLink" : false, "keyword" : "Home"  },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Buy a new policy" : {
        "msg" : [
            "That's great 🤩 ! <b>Your family</b> 👨&zwj;👩&zwj;👦 relies on you for care 😇, security and financial stability💰. With <b>Life insurance</b> 🛡️, you can guarantee ✅ you'll always be there for your family 👨&zwj;👩&zwj;👦, even in your absence.",
            "Call Assistance service is available from 10AM to 7PM (between Mon-Sat) except Public Holidays."
        ],
        "utterance" : "That’s great! Your family relies on you for care, security and financial stability. With life insurance, you can guarantee you’ll always be there for your family, even in your absence. Call Assistance service is available from 10AM to 7PM (between Mon-Sat) except Public Holidays.",
        "type" : "button",
        "option" : [
            { "btn" : "To explore our wide range of plans", "isLink" : false, "keyword": "To explore our wide range of plans" },
            { "btn" : "Speak to an insurance expert", "isLink" : false, "keyword" : "Speak to an insurance expert" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "To explore our wide range of plans" : {
        "msg" : ["Please select the plan you want to explore"],
        "utterance" : "Please select the plan you want to explore",
        "type" : "button",
        "option" : [
            { "btn" : "Term Plan - ICICI Pru iProtect Smart", "isLink" : false, "keyword" : "Term plan" },
            { "btn" : "Term Plan-ICICI Pru iProtect Return of Premium ", "isLink" : false, "keyword" : "Term plan-ROP" },
            { "btn" : "Wealth Plan- ICICI Pru Signature Online", "isLink" : false, "keyword" : "Wealth plan" },
            { "btn" : "Retirement Plan- ICICI Pru GPP-Flexi", "isLink" : false, "keyword" : "Retirement plan" },
            { "btn" : "Saving Plan- ICICI Pru GIFT", "isLink" : false, "keyword" : "Saving plan" },
            { "btn" : "Health Plan- ICICI Pru Heart Cancer Protect", "isLink" : false, "keyword" : "Health plan" },
            { "btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>All Plans</a>", "isLink" : true },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Check other plans" : {
        "msg" : ["Please select the plan you want to explore"],
        "utterance" : "Please select the plan you want to explore",
        "type" : "button",
        "option" : [
            { "btn" : "Term Plan - ICICI Pru iProtect Smart", "isLink" : false, "keyword" : "Term plan" },
            { "btn" : "Term Plan-ICICI Pru iProtect Return of Premium ", "isLink" : false, "keyword" : "Term plan-ROP" },
            { "btn" : "Wealth Plan- ICICI Pru Signature Online", "isLink" : false, "keyword" : "Wealth plan" },
            { "btn" : "Retirement Plan- ICICI Pru GPP-Flexi", "isLink" : false, "keyword" : "Retirement plan" },
            { "btn" : "Saving Plan- ICICI Pru GIFT", "isLink" : false, "keyword" : "Saving plan" },
            { "btn" : "Health Plan- ICICI Pru Heart Cancer Protect", "isLink" : false, "keyword" : "Health plan" },
            { "btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>All Plans</a>", "isLink" : true },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Term plan" : {
        "msg" : [
            "What makes this plan special:<br> Protect your loved ones with a large cover <b>at affordable rates</b><br><b>Health cover</b> against <b>34 critical illnesses</b> (optional)",
            "<b>Accidental death benefit</b> up to <b>2 crore</b> (optional)<br>Whole life insurance: Lasts till <b>99 years of age</b>",
            "Save up to <b>65% on premiums</b> with the <b>limited pay option</b> <br><b>Tax benefit</b> up to <b>Rs54,600</b>",
        ],
        "utterance" : "Here are the top features of the selected product",
        "type" : "button",
        "option" : [
            { "btn" : "Request a call back", "isLink" : false, "keyword" : "Request a call back" },
            { "btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>To know more and purcahse online</a>", "isLink" : true },
            { "btn" : "Check other plans", "isLink" : false, "keyword" : "Check other plans" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Term plan-ROP" : {
        "msg" : [
            "What makes this plan special:<br>Ensure right life cover to <b>protect yourself</b> adequately at every <b>life-stage</b><br><b>Get 105% of your premium back</b> or <b>get monthly income</b> from <b>age 60 on survival/maturity</b><br>",
            "Get <b>claim payout on diagnosis of 64 critical illnesses</b> (optional)<br><b>Accidental death benefit</b> cover up to <b>Rs 2 crore</b> (optional)<br>",
            "<b>Tax benefit</b> as per prevailing tax laws",
        ],
        "utterance" : "Here are the top features of the selected product",
        "type" : "button",
        "option" : [
            { "btn" : "Request a call back", "isLink" : false, "keyword" : "Request a call back" },
            { "btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>To know more and purcahse online</a>", "isLink" : true },
            { "btn" : "Check other plans", "isLink" : false, "keyword" : "Check other plans" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Wealth plan" : {
        "msg" : [
            "What makes this plan special:<br>Get the <b>claim amount on diagnosis</b><br><b>No restrictions on your choice of hospital</b><br>",
            "<b>Waiver of future premiums</b> for minor conditions of cancer or heart for full policy term<br>Get tax benefits up to Rs 7,800 under <b>Section 80D</b> of the Income Tax Act<br>",
            "Get an <b>Instant Premium Payment Receipt</b><br><b>Get covered up to 40 years</b> without any <b>increase in premium amount</b><br>",
        ],
        "utterance" : "Here are the top features of the selected product",
        "type" : "button",
        "option" : [
            { "btn" : "Request a call back", "isLink" : false, "keyword" : "Request a call back" },
            { "btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>To know more and purcahse online</a>", "isLink" : true },
            { "btn" : "Check other plans", "isLink" : false, "keyword" : "Check other plans" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Retirement plan" : {
        "msg" : [
            "What makes this plan special:<br>Provides <b>financial protection</b> for <b>your loved ones</b> with a life insurance cover<br><b>Return of mortality</b> and <b>policy administration charges</b><br>",
            "<b>Get tax benefit</b> on premiums paid u/s 80C and <b>receive maturity amount</b> tax-free subject to Section10 (10D)<br><b>Withdraw money regularly</b> from your policy with <b>Systematic Withdrawal Plan</b> (SWP)<br>",
            "Entire premium amount without any deductions is invested in the <b>funds of your choice</b><br><b>Enjoy policy benefits till 99 years</b> of age with the <b>whole life policy term option</b><br>With the <b>Fixed Portfolio Strategy</b> make unlimited <b>free switches between the funds</b>",
        ],
        "utterance" : "Here are the top features of the selected product",
        "type" : "button",
        "option" : [
            { "btn" : "Request a call back", "isLink" : false, "keyword" : "Request a call back" },
            { "btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>To know more and purcahse online</a>", "isLink" : true },
            { "btn" : "Check other plans", "isLink" : false, "keyword" : "Check other plans" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Saving plan" : {
        "msg" : [
            "What makes this plan special:<br><b>Get Guaranteed Benefits</b> in the form of <b>Lump Sum or Regular Income</b><br>Option to <b>avail Benefits from 2nd year onwards</b><br>",
            "<b>Get Income on a special date</b> with Save the Date feature<br>Enjoy <b>Tax Benefits under Section 80C and 10(10D)</b><br>",
            "<b>Secure your family</b> financially with Life Cover",
        ],
        "utterance" : "Here are the top features of the selected product",
        "type" : "button",
        "option" : [
            { "btn" : "Request a call back", "isLink" : false, "keyword" : "Request a call back" },
            { "btn" : "<a target='_blank' href='https://www.google.com class='bot-options-link-btn'>To know more and purcahse online</a>", "isLink" : true },
            { "btn" : "Check other plans", "isLink" : false, "keyword" : "Check other plans" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Health plan" : {
        "msg" : [
            "What makes this plan special:<br>A <b>regular-pay</b> deferred annuity plan that helps you gradually build the <b>retirement savings and provide guaranteed income for life</b><br><b>Flexible premium paying terms</b> and deferment periods<br>",
            "Meet your <b>healthcare and lifestyle</b> needs through <b>additional pay out options</b><br>Financial security for <b>your family</b> even in your absence, with the <b>Waiver of Premium feature</b><br>",
            "<b>Annuity plan</b> can cover either single or joint life<br><b>Tax benefits</b> as per prevailing tax laws<br>",
        ],
        "utterance" : "Here are the top features of the selected product",
        "type" : "button",
        "option" : [
            { "btn" : "Request a call back", "isLink" : false, "keyword" : "Request a call back" },
            { "btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>To know more and purcahse online</a>", "isLink" : true },
            { "btn" : "Check other plans", "isLink" : false, "keyword" : "Check other plans" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Request a call back" : {
        "msg" : ["To help you choose a correct product from our wide range of plans which will suit your needs. Please help me with your mobile number (10 digit) to receive a call back for assistance."],
        "utterance" : "To help you choose a correct product from our wide range of plans which will suit your needs. Please help me with your mobile number (10 digit) to receive a call back for assistance.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Speak to an insurance expert" : {
        "msg" : ["To help you choose a correct product from our wide range of plans which will suit your needs. Please help me with your mobile number (10 digit) to receive a call back for assistance."],
        "utterance" : "To help you choose a correct product from our wide range of plans which will suit your needs. Please help me with your mobile number (10 digit) to receive a call back for assistance.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Track new application" : {
        "msg" : ["Sure! To track your application/policy simply <a target='blank' href='https://buy.iciciprulife.com'> Click here </a>"],
        "utterance" : "Sure! To track your application/policy simply Click here",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Download mobile app" : {
        "msg" : [
            "You can now access your policy at your fingertips with the ICICI prudential MobileApp: <br/> • Login via fingerprint, Face ID &amp; OTP<br/>• Multiple policy transactions at a click -policy statements, download welcome kit premium payment, fund switch etc<br/>• Freedom to access policy details without network (First time application has to be connected via internet.)",
            "Download today and experience the freedom of transacting with your phone<br/><b>Android</b> - <a target='_blank' rel='noopener noreferre' href='https://s.ipru.co/lpjox2wa'>Click here</a> <br/><b>iOS</b> - <a target='_blank' rel='noopener noreferrer' href='https://s.ipru.co/mwheymm0'>Click here</a></div>"
        ],
        "utterance" : "Here are the details",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Death and Health claim" : {
        "msg" : ["Please choose the option you are looking for."],
        "utterance" : "Please choose the option you are looking for.",
        "type" : "button",
        "option" : [
            { "btn" : "Register a claim", "isLink" : false, "keyword" : "Register a claim" },
            { "btn" : "Share documents", "isLink" : false, "keyword" : "Document upload" },
            { "btn" : "Track claim status", "isLink" : false, "keyword" : "Track claim status" },
            { "btn" : "Document checklist", "isLink" : false,"keyword" : "Document checklist" },
            { "btn" : "FAQs for claims", "isLink" : false,"keyword" : "FAQs for claims" },
            { "btn" : "Home", "isLink" : false,"keyword" : "Home" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Policy details" : {
        "msg" : ["Surely ! To help you with your policy details please enter your 8 digit policy number or (10 digit) mobile number?"],
        "utterance" : "Surely ! To help you with your policy details please enter your 8 digit policy number or (10 digit) mobile number?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "1 1 1991" : {
        "msg" : ["Hi <b>User name</b> here are the details for policy number <b>A1234567 - ICICI Pru GIFT Long Term</b> plan issued on <b>31-Dec-1921</b> which is currently <b>In Force</b>.The life assured is <b>User name</b>. You are covered for <b>Rs 998880.0</b>, premium payable is <b>Monthly</b> of <b>Rs 8698</b> and payment mode is <b>Electronic</b>.The next premium is due on <b>31-Aug-2026</b>; an advance of <b>0</b> has been received towards the premium. The policy is maturing on <b>31-Dec-1949</b>."],
        "utterance" : "Here are your details",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "intuitive",
            "name" : "User name",
            "option" : [
                {"btn" : "Pol No: 12345678 Premium Amount: 4022 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : "Pol No: 87654321 Premium Amount: 402029 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : " Pol No: 88888888 Premium Amount: 4002 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
            ]
        }
    },
    "Fund value" : {
        "msg" : ["Surely ! To help you with your fund value please enter your 8 digit policy number or (10 digit) mobile number?"],
        "utterance" : "Surely ! To help you with your fund value please enter your 8 digit policy number or (10 digit) mobile number?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "2 2 1992" : {
        "msg" : [
            "The fund value for policy no. <b>08643572</b> is 💸 <b>₹437946.08</b> as on <b>13-Sep-2022</b><br>Fund details mentioned below 👇:",
            "Fund Details:<br><br>Fund Name : <b>Protector</b><br>Units: <b>3488.57</b><br>NAV: <b>41.93</b><br>Protector Value: 💸 <b>₹146280.09</b><br><br>Fund Name : <b>F.Balanced</b><br>Units: <b>7925.99</b><br>NAV: <b>36.80</b><br>F.Balanced Value: 💸 <b>₹291665.98</b><br><br><b>Note: Fund value is calculated as per the latest NAV declared.</b>"
        ],
        "utterance" : ["Hi User name, here are details with us"],
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "intuitive",
            "name" : "User name",
            "option" : [
                {"btn" : "Pol No: 12345678 Premium Amount: 4022 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : "Pol No: 87654321 Premium Amount: 402029 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : " Pol No: 88888888 Premium Amount: 4002 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
            ]
        }
    },
    "Profile details" : {
        "msg" : ["Surely ! To help you with your profile details please enter your 8 digit policy number or (10 digit) mobile number?"],
        "utterance" : "Surely ! To help you with your profile details please enter your 8 digit policy number or (10 digit) mobile number?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "3 3 1993" : {
        "msg" : ["Hi <b>User name</b> , your details updated with us: <br><br> <b>Address :</b>  Test HOUSE,Testing ,Tester Test Tested ..,Test 123456, <br><b>Mobile No :</b> 9999999999,  <br><b>Email-id :</b> TEST123@GMAIL.COM, <br><b>Date of birth :</b> 31-JUL-1992, <br><b>PAN :</b> TTVXXXXX5N"],
        "utterance" : ["Hi User name, here are details with us"],
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "intuitive",
            "name" : "User name",
            "option" : [
                {"btn" : "Pol No: 12345678 Premium Amount: 4022 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : "Pol No: 87654321 Premium Amount: 402029 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : " Pol No: 88888888 Premium Amount: 4002 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
            ]
        }
    },
    "Statements" : {
        "msg" : ["To help you download your policy statement, may I have your 8 digit policy number or (10 digit) mobile number?"],
        "utterance" : "To help you download your policy statement, may I have your 8 digit policy number or (10 digit) mobile number?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "4 4 1994" : {
        "msg" : ["Hi <b>User name</b>, select the policy you want to view or download statement(s) for:"],
        "utterance" : ["Hi User name, select the policy you want to view or download statements for:"],
        "type" : "button",
        "option" : [
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
        ],
        "prompt" : {
            "type" : "intuitive",
            "name" : "User name",
            "option" : [
                {"btn" : "Pol No: 12345678 Premium Amount: 4022 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : "Pol No: 87654321 Premium Amount: 402029 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : " Pol No: 88888888 Premium Amount: 4002 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
            ]
        }
    },
    "Pay premium" : {
        "msg" : ["To help you please select from below options. <br/><b>Note: </b> Call Assistance service is available from 10AM to 7PM (between Mon-Sat) except Public Holidays."],
        "utterance" : "To help you please select from below options. Note: Call Assistance service is available from 10AM to 7PM between Mon-Sat except Public Holidays.",
        "type" : "button",
        "option" : [
            { "btn" : "Pay online", "isLink" : false, "keyword" : "Pay online" },
            { "btn" : "Receive a call for assistance", "isLink" : false, "keyword" : "Receive a call for assistance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Pay online" : {
        "msg" : ["Sure ! To help you with that may I please have your policy number (8 digit) or mobile number (10 digit)?"],
        "utterance" : "Sure ! To help you with that may I please have your policy number (8 digit) or mobile number (10 digit)?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "5 5 1995" : {
        "msg" : [" Hi <b>User</b>, please click on the policy to make payment:"],
        "utterance" : [" Hi User,please click on the policy to make payment:"],
        "type" : "button",
        "option" : [
            {"btn" : "<a href='https://www.google.com' target='_blank' class='bot-options-link-btn'> Pol No: 12345678 Amt Due: 18000 <br> Due Date: 24-Jan-2023 </a>", isLink: true, "keyword" : "" },
        ],
        "prompt" : {
            "type" : "feedback",
            "option" : []
        },
    },
    "Receive a call for assistance" : {
        "msg" : ["Hi, we will surely help you with the premium payment by connecting you with our premium collection team. Please enter the policy number (8 digit) or registered mobile number (10 digit)"],
        "utterance" : "Hi, we will surely help you with the premium payment by connecting you with our premium collection team. Please enter the policy number (8 digit) or registered mobile number (10 digit)",
        "type" : "input",
        "option" : []
        ,
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Invest fund" : {
        "msg" : ["Surely ! To help you with your invest fund please enter your 8 digit policy number or (10 digit) mobile number?"],
        "utterance" : "Surely ! To help you with your nvest fund please enter your 8 digit policy number or (10 digit) mobile number?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Top up" : {
        "msg" : ["Surely ! To help you with your invest fund please enter your 8 digit policy number or (10 digit) mobile number?"],
        "utterance" : "Surely ! To help you with your nvest fund please enter your 8 digit policy number or (10 digit) mobile number?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "6 6 1996" : {
        "msg" : [" Hi <b>User name</b>, please select the policy number that you want to Top up for:"],
        "utterance" : [" Hi User, please select the policy number that you want to Top up for:"],
        "type" : "button",
        "option" : [
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
        ],
        "prompt" : {
            "type" : "intuitive",
            "name" : "User name",
            "option" : [
                {"btn" : "Pol No: 12345678 Premium Amount: 4022 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : "Pol No: 87654321 Premium Amount: 402029 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : " Pol No: 88888888 Premium Amount: 4002 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
            ]
        }
    },
    "Pan update" : {
        "msg" : ["To help you in updating your PAN, may I have your policy number (8 digit) or registered mobile number (10 digit)?"],
        "utterance" : "To help you in updating your PAN, may I have your policy number (8 digit) or registered mobile number (10 digit)?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "intuitive",
            "name" : "",
            "option" : []
        },
    },
    "7 7 1997" : {
        "msg" : ["Hi <b>User name</b>, <a href='https://www.google.com' target='_blank'>click here </a> to update your PAN."],
        "utterance" : ["Hi User , click here to update your PAN."],
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "intuitive",
            "name" : "User name",
            "option" : [
                {"btn" : "Pol No: 12345678 Premium Amount: 4022 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : "Pol No: 87654321 Premium Amount: 402029 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : " Pol No: 88888888 Premium Amount: 4002 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
            ]
        },
    },
    "Set SI" : {
        "msg" : ["I understand you want to create/ change the standing instructions for auto payment of premium. To help you, can I have your policy number (8 digit) or registered mobile number (10 digit)?"],
        "utterance" : "I understand you want to create/ change the standing instructions for auto payment of premium. To help you, can I have your policy number (8 digit) or registered mobile number (10 digit)?",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "8 8 1998" : {
        "msg" : ["Hi <b>User name</b>, select the policy you want to set standing instruction for:"],
        "utterance" : ["Hi select the policy you want to set standing instruction for:"],
        "type" : "button",
        "option" : [
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>87654321</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>88888888</a>", isLink: true, "keyword" : ""},
        ],
        "prompt" : {
            "type" : "intuitive",
            "name" : "User name",
            "option" : [
                {"btn" : "Pol No: 12345678 Premium Amount: 4022 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : "Pol No: 87654321 Premium Amount: 402029 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
                {"btn" : " Pol No: 88888888 Premium Amount: 4002 Due Date: 22-Jul-2022", isLink: false, "keyword" : "88888888"},
            ]
        }
    },
    "Medical report" : {
        "msg" : ["Medical report is only available if you have undergone a physical test and your policy is already issued. To help you download your Medical Report, may I have your policy number (8 digit) or registered mobile number (10 digit)?"],
        "utterance" : "Medical report is only available if you have undergone a physical test and your policy is already issued. To help you download your Medical Report, may I have your policy number (8 digit) or registered mobile number (10 digit)?",
        "type" : "input",
        "option" : []
    },
    "9 9 1999" : {
        "msg" : ["Hi <b>User name</b>, select the policy you want Medical Report for:"],
        "utterance" : ["Hi User, select the policy you want Medical Report for:"],
        "type" : "button",
        "option" : [
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
        ],
        "prompt" : {
            "type" : "contact_update",
            "name" : "User name",
            "option" : ["Alternate email number"]
        },
    },
    "12345678" : {
        "msg" : ["Please enter your Date of Birth for verification. For example : If your date of birth is 6 Jan 1992 enter 06 01 1992."],
        "utterance" : "Please enter your Date of Birth for verification. For example : If your date of birth is 6 Jan 1992 enter 06 01 1992.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "123456" : {
        "msg" : ["Thanks! I got that. Now please enter the confirmation code sent to your mobile number: 123XXXXX90 and registered email-id : ABCXXXXXXXXXX@GMAIL.COM"],
        "utterance" : "Thanks! I got that. Now please enter the confirmation code sent to your mobile number and registered email-id",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "intuitive" : {
        "msg" : ["Hi <b>User name</b>, premium of your policy/ies is due for payment. Simply click onthe policy you want to renew and we can assist you with the payment:"],
        "utterance" : "Hi User, premium of your policies is due for payment. Simply click onthe policy you want to renew and we can assist you with the payment:",
        "type" : "button",
        "option" : [
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>12345678</a>", isLink: true, "keyword" : ""},
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "contact_update" : {
        "msg" : ["Hi <b>User name</b>, we have noticed that some of your contact details are not updated with us. To receive regular alerts about your ICICI Pru Life policy, kindly update the below detail(s):<br/><b>Alternate mobile number</b><br/>Here are 4 quick ways to update these detail(s). Select your preferred channel to know more.<br>"],
        "utterance" : "Hi User name, we have noticed that some of your contact details are not updated with us. To receive regular alerts about your ICICI Pru Life policy, kindly update the below details. Alternate mobile number. Here are 4 quick ways to update these details. Select your preferred channel to know more.",
        "type" : "button",
        "option" : [
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>Mobile app</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>Website</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>Call center</a>", isLink: true, "keyword" : ""},
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>ICICI Pru Life branch</a>", isLink: true, "keyword" : ""},
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "feedback": {
        "msg" : ["Was it helpful ?"],
        "utterance" : "Was it helpful.",
        "type" : "feedback",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Yes": {
        "msg" : ["I am glad. You can continue to check other services:"],
        "utterance" : "I am glad. You can continue to check other services:",
        "type" : "button",
        "option" : [
            { "btn" : "Buy a policy", "isLink" : false, "keyword" : "I want to buy a policy" },
            { "btn" : "Track new application", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Top up", "isLink" : false, "keyword" : "Top up" },
            { "btn" : "Profile details", "isLink" : false, "keyword" : "Profile details" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Group insurance", "isLink" : false, "keyword" : "Group insurance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "No": {
        "msg" : [
            "Apologies for the inconvenience,I am still in learning phase. Please connect with us on @ 1860 266 7766 to resolve your queries. Continue to check other services:",
            "If you an NRI customer, Please call us at +91 22 6193 0777."
        ],
        "utterance" : "Apologies for the inconvenience,I am still in learning phase. Please connect with us on @ 1860 266 7766 to resolve your queries. Continue to check other services. If you an NRI customer, Please call us at +91 22 6193 0777.",
        "type" : "button",
        "option" : [
            { "btn" : "Track status", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Locate us", "isLink" : false, "keyword" : "Locate us" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Fund value", "isLink" : false, "keyword" : "Fund value" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Chat with agent", "isLink" : false, "keyword" : "Agent_support" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Locate us" : {
        "msg" : [
            "<a target='blank' href='To get a call for assistance'>Click Here</a> to locate a nearest ICICI Prudential branch.",
            "By the way, there are a host of online services available for you that you can access by downloading our mobile app.Download today and experience the freedom of transacting with your phone<br/> Android - <a target='blank' href ='https://s.ipru.co/lpjox2wa'>Click here</a> <br/>IOS -  <a target='blank' href = 'https://s.ipru.co/mwheymm0'>Click here</a>"
        ],
        "utterance" : "Click Here to locate a nearest ICICI Prudential branch. By the way, there are a host of online services available for you that you can access by downloading our mobile app.Download today and experience the freedom of transacting with your phone<br/> Android - <a target='blank' href ='https://s.ipru.co/lpjox2wa'>Click here</a> <br/>IOS -  <a target='blank' href = 'https://s.ipru.co/mwheymm0'>Click here</a>",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Agent_support" : {
        "msg" : [
            "<b>Welcome to our chat assistance.</b> Please be with us. Our officer would be here to assist you shortly.",
            "User name Raut has joined the chat.",
            "Hello!! Hope you are doing well. My name is Agent Name and I am here to assist you today.<br><br>To assist you further, request you to allow me few minutes to go through your previous chat interaction with LiGO",
        ],
        "utterance" : "Welcome to our chat assistance. Please be with us. Our officer would be here to assist you shortly.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "End chat" : {
        "msg" : ["ThankYou."],
        "utterance" : "Thankyou",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "I have a query" : {
        "msg" : ["Okay enter below your query you have"],
        "utterance" : "Okay enter below your query you have",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        }
    },
    "DTAA" : {
        "msg" : [
            "NRIs can avoid paying double tax as per the Double Tax Avoidance Agreement (DTAA). Usually, Non-Resident Indians (NRI) live abroad, but earn income in India. In such cases, it is possible that the income earned in India would attract tax in India as well as in the country of the NRI’s residence. This means that they would have to pay tax twice on the same income.",
            "The Double Tax Avoidance Agreement is a treaty signed by two countries. The agreement is signed to make a country an attractive destination as well as to enable NRIs to get relief from having to pay taxes multiple times. DTAA does not mean that the NRI can completely avoid taxes, but it does mean that the NRI can avoid paying higher taxes in both countries. DTAA does allow an NRI to cut down on their tax implications on the income earned in India. DTAA also reduces the instances of tax evasion.",
            "DTAA, signed by India with different countries, fixes a specific rate at which tax has to be deducted on income paid to residents of that country. This means that when NRIs earn an income in India, the TDS applicable would be according to the rates set in the Double Tax Avoidance Agreement with that country.",
            "Below are more servicing options:",
        ],
        "utterance" : "Hi here are the details.",
        "type" : "button",
        "option" : [
            { "btn" : "Buy a policy", "isLink" : false, "keyword" : "I want to buy a policy" },
            { "btn" : "Track new application", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Top up", "isLink" : false, "keyword" : "Top up" },
            { "btn" : "Profile details", "isLink" : false, "keyword" : "Profile details" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Group insurance", "isLink" : false, "keyword" : "Group insurance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "TRC" : {
        "msg" : [
            "Tax Residency/Domicile Certificate is a certificate issued by the tax authorities/ revenue department of the foreign country stating that the person is Tax resident in their country. Tax Residency Certificate along with Form 10F must be submitted at the time of payout.",
            "Below are more servicing options:"
        ],
        "utterance" : "Hi here are the details.",
        "type" : "button",
        "option" : [
            { "btn" : "Buy a policy", "isLink" : false, "keyword" : "I want to buy a policy" },
            { "btn" : "Track new application", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Top up", "isLink" : false, "keyword" : "Top up" },
            { "btn" : "Profile details", "isLink" : false, "keyword" : "Profile details" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Group insurance", "isLink" : false, "keyword" : "Group insurance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Form 10F" : {
        "msg" : [
            "Form 10F as prescribed under Income tax rules, 1962 declaring that he has obtained TRC, duly filled and completed in all respects must be submitted along with the TRC at the time of payout.",
            "Below are more servicing options:"
        ],
        "utterance" : "Hi here are the details.",
        "type" : "button",
        "option" : [
            { "btn" : "Buy a policy", "isLink" : false, "keyword" : "I want to buy a policy" },
            { "btn" : "Track new application", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Top up", "isLink" : false, "keyword" : "Top up" },
            { "btn" : "Profile details", "isLink" : false, "keyword" : "Profile details" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Group insurance", "isLink" : false, "keyword" : "Group insurance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "More servicing options" : {
        "msg" : ["Below are more servicing options:"],
        "utterance" : "Below are more servicing options:",
        "type" : "button",
        "option" : [
            { "btn" : "Buy a policy", "isLink" : false, "keyword" : "I want to buy a policy" },
            { "btn" : "Track new application", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Top up", "isLink" : false, "keyword" : "Top up" },
            { "btn" : "Profile details", "isLink" : false, "keyword" : "Profile details" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Group insurance", "isLink" : false, "keyword" : "Group insurance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "EVC" : {
        "msg" : ["Existence verification check is applicable for customers who are receiving pension income from any of their pension policies with us. Once you start receiving pension income, every year/ or every three years we do a verification check of your policy. This is known as the Existence verification check."],
        "utterance" : "Existence verification check is applicable for customers who are receiving pension income from any of their pension policies with us. Once you start receiving pension income, every year/ or every three years we do a verification check of your policy. This is known as the Existence verification check.",
        "type" : "button",
        "option" : [
            { "btn" : "Individual customer", "isLink" : false, "keyword" : "Individual customer" },
            { "btn" : "Group annuity/Super annuation customer", "isLink" : false, "keyword" : "Group annuity/Super annuation customer" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Individual customer" : {
        "msg" : ["You can simply complete your life existence verification at the click of a button on your smart phone, tablet or laptop from the comfort of your home on our website.<br/>Click here to login to our website with your user id and password &gt; Go to My Dashboard &gt; Go to More Services &gt; Go to Existence Verification button. <a href='https://www.google.com'>click here</a><br/>The website is best viewed on the following browsers: <br/>1. Chrome (Version 30 and above for Desktop and Android phones)<br/>2. Firefox (Version 30 and above)<br/>3. Safari (Version 8 and above for Mac and iOS phones)<br/>Some features of this digital journey may not be supported by Internet Explorer <br/>Please click on 'Allow' when browser asks for camera permission.<br/>The browser version can be checked by going into ’Settings’ of your browser and selecting ’About’<br/>In case of more queries please write to us on lifeline@iciciprulife.com from your registered email id. <br/>"],
        "utterance" : "Here are the details",
        "type" : "button",
        "option" : [
            { "btn" : "More ways to submit your EVC", "isLink" : false, "keyword" : "More ways to submit your EVC" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "More ways to submit your EVC" : {
        "msg" : ["You can also complete the Existence verification check of your policy via Email, at our branch or by sending your documents to us by courier.<br/>Required documents:<br/>1. Signed copy of your Life Verification Certificate with your details and signed by any of the verifiers, i.e. Post Master, Bank Manager, ICICI Pru employee mentioned in the certificate. Click here to download the format <br/><a href='https://www.google.com'>click here</a><br/>2. Signed copy of Photo Identity Proof such as your Pan Card, Passport, Driving License etc. This document also needs to be signed by one of the verifiers mentioned in the certificate.<br/>You can submit the documents through any of these options:<br/>1. Email us: Email a scanned copy of the form and documents to lifeline@iciciprulife.com from your registered email id. Do mention your policy number in the subject line.<br/>2. Our Branch: Submit the documents at any of our branches. To locate the nearest branch,<a href='https://www.google.com'>click here</a><br/>3. Courier: Courier the form/ documents to:<br/>Pension department, ICICI Prudential Life Insurance Co. Ltd."],
        "utterance" : "Here are the details",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Group annuity/Super annuation customer" : {
        "msg" : ["I can help you with :"],
        "utterance" : "I can help you with :",
        "type" : "button",
        "option" : [
            { "btn" : "To complete life existence verification online", "isLink" : false, "keyword" : "To complete life existence verification online" },
            { "btn" : "More ways to submit your EVC", "isLink" : false, "keyword" : "More ways to submit your EVC" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "To complete life existence verification online" : {
        "msg" : ["The Digital Life Verification is a three step process after receiving an OTP on your registered mobile:<br/>1. Enter your date of birth and PAN<br//>2. Upload your photo identity proof<br//>3. Click and upload your selfie<br//><b>Watch Video over here :</b> <a href='https://www.google.com' target='blank'>Click here</a><br/>To help you generate your Existence/Life Verification Certificate, please enter your Group Immediate Annuity Contract Number:"],
        "utterance" : "The Digital Life Verification is a three step process after receiving an OTP on your registered mobile:<br/>1. Enter your date of birth and PAN<br//>2. Upload your photo identity proof<br//>3. Click and upload your selfie<br//><b>Watch Video over here :</b> <a href='https://www.google.com' target='blank'>Click here</a><br/>To help you generate your Existence/Life Verification Certificate, please enter your Group Immediate Annuity Contract Number:",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "111111" : {
        "msg" : ["Please enter your Date of Birth for verification. For example : If your date of birth is 6 Jan 1992 enter 06 01 1992."],
        "utterance" : "Please enter your Date of Birth for verification. For example : If your date of birth is 6 Jan 1992 enter 06 01 1992.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "12 jul 1972" : {
        "msg" : ["Please <a href='https://www.google.com' target='_blank'> Click Here </a> to proceed with the process.<br>This digital process can be best completed on the following browsers:<br>1. Chrome (Version 30 and above for Desktop and Android phones)<br>2. Firefox (Version 30 and above)<br>3. Safari (Version 8 and above for Mac and iOS phones)<br>Please click on <b>Allow</b> when browser asks for camera permission<br>"],
        "utterance" : "Please Click Here to proceed with the process. This digital process can be best completed on the following browsers: 1. Chrome (Version 30 and above for Desktop and Android phones) 2. Firefox (Version 30 and above) 3. Safari (Version 8 and above for Mac and iOS phones) Please click on Allow when browser asks for camera permission",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "feedback",
            "option" : []
        },
    },
    "Register a claim" : {
        "msg" : ["Please let us know which claim you want to register:"],
        "utterance" : "Please let us know which claim you want to register:",
        "type" : "button",
        "option" : [
            { "btn" : "Life insurance claim", "isLink" : false, "keyword" : "Life insurance claim" },
            { "btn" : "Health insurance claim", "isLink" : false, "keyword" : "Health insurance claim" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Life insurance claim" : {
        "msg" : [
            "We are sorry for your loss. We are committed to providing you complete support in this hour of need. You can register claim online, just visit: Click herePlease keep the policy number/PAN and Date of Birth of the life assured handy.",
            "Call Assistance service is available from 10AM to 7PM (between Mon-Sat) except Public Holidays."
        ],
        "utterance" : "We are sorry for your loss. We are committed to providing you complete support in this hour of need. You can register claim online, just visit: Click herePlease keep the policy number/PAN and Date of Birth of the life assured handy. Call Assistance service is available from 10AM to 7PM (between Mon-Sat) except Public Holidays.",
        "type" : "button",
        "option" : [
            { "btn" : "To get a call for assistance", "isLink" : false, "keyword" : "To get a call for assistance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Health insurance claim" : {
        "msg" : [
            "We are sorry for your loss. We are committed to providing you complete support in this hour of need. You can register claim online, just visit: Click herePlease keep the policy number/PAN and Date of Birth of the life assured handy.",
            "Call Assistance service is available from 10AM to 7PM (between Mon-Sat) except Public Holidays."
        ],
        "utterance" : "We are sorry for your loss. We are committed to providing you complete support in this hour of need. You can register claim online, just visit: Click herePlease keep the policy number/PAN and Date of Birth of the life assured handy. Call Assistance service is available from 10AM to 7PM (between Mon-Sat) except Public Holidays.",
        "type" : "button",
        "option" : [
            { "btn" : "To get a call for assistance", "isLink" : false, "keyword" : "To get a call for assistance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Document upload" : {
        "msg" : ["You can upload documents for below mentioned categories <br/><b> New application related / Claims related / Update Bank details for Payout </b></br/> Now please Upload your document and follow the further steps <br/><b>Tips: Upload one document at a time.</b>"],
        "utterance" : "You can upload documents for below mentioned categories New application related / Claims related / Update Bank details for PayoutNow please Upload your document and follow the further stepsTips: Upload one document at a time.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Track claim status" : {
        "msg" : ["Sure! To help you with your claim status please enter your claims number."],
        "utterance" : "Sure! To help you with your claim status please enter your claims number.]",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Document checklist" : {
        "msg" : ['Here is the list of documents required: <br/> For Death claim <a target="_blank" href="https://www.google.com">Click here</a> <br/> For Health claim <a target="_blank" href="https://www.google.com">Click here</a>'],
        "utterance" : "Here's the list of documents required: For Death claim Click here For Health claim Click here",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "FAQs for claims" : {
        "msg" : ['To get answers to most frequently asked questions visit <a target="_blank" href="https://buy.iciciprulife.com">Click here.</a>'],
        "utterance" : "To get answers to most frequently asked questions visit Click here",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "UDI123456" : {
        "msg" : ["Your claim has been approved. Payment is being processed & relevant payment details will be sent to you shortly. For any assistance, please contact 24X7 claim care on 1860 266 7766."],
        "utterance" : "Your claim has been approved. Payment is being processed & relevant payment details will be sent to you shortly. For any assistance, please contact 24X7 claim care on 1860 266 7766.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Uploaded document" : {
        "msg" : ["Please select the category for which you have uploaded the document:"],
        "utterance" : "Please select the category for which you have uploaded the document:",
        "type" : "button",
        "option" : [
            { "btn" : "Your new application which is due for issuance", "isLink" : false, "keyword" : "Your new application which is due for issuance" },
            { "btn" : "Claim related", "isLink" : false, "keyword" : "Claim related" },
            { "btn" : "Update bank details", "isLink" : false, "keyword" : "Update bank details" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Claim related" : {
        "msg" : ["Please select the type of uploaded Claim related document by you:"],
        "utterance" : "Please select the type of uploaded Claim related document by you:",
        "type" : "button",
        "option" : [
            { "btn" : "Claim intimation", "isLink" : false, "keyword" : "Claim intimation" },
            { "btn" : "Additional claim related document", "isLink" : false, "keyword" : "Additional claim related document" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Your new application which is due for issuance" : {
        "msg" : ["Please select the uploaded type of document by you:"],
        "utterance" : "Please select the uploaded type of document by you:",
        "type" : "button",
        "option" : [
            { "btn" : "Photo id", "isLink" : false, "keyword" : "Photo id" },
            { "btn" : "Age proof", "isLink" : false, "keyword" : "Age proof" },
            { "btn" : "Address proof", "isLink" : false, "keyword" : "Address proof" },
            { "btn" : "Payout mandate", "isLink" : false, "keyword" : "Payout mandate" },
            { "btn" : "Income document", "isLink" : false, "keyword" : "Income document" },
            { "btn" : "Photo", "isLink" : false, "keyword" : "Photo" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Photo id" : {
        "msg" : ["Please select the document uploaded by you:"],
        "utterance" : "Please select the document uploaded by you:",
        "type" : "button",
        "option" : [
            { "btn" : "PAN card", "isLink" : false, "keyword" : "PAN card" },
            { "btn" : "Aadhar card", "isLink" : false, "keyword" : "Aadhar card" },
            { "btn" : "Passport", "isLink" : false, "keyword" : "Passport" },
            { "btn" : "Driving license", "isLink" : false, "keyword" : "Driving license" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Age proof" : {
        "msg" : ["Please select the document uploaded by you:"],
        "utterance" : "Please select the document uploaded by you:",
        "type" : "button",
        "option" : [
            { "btn" : "PAN card", "isLink" : false, "keyword" : "PAN card" },
            { "btn" : "Aadhar card", "isLink" : false, "keyword" : "Aadhar card" },
            { "btn" : "Passport", "isLink" : false, "keyword" : "Passport" },
            { "btn" : "Driving license", "isLink" : false, "keyword" : "Driving license" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Address proof" : {
        "msg" : ["Please select the document uploaded by you:"],
        "utterance" : "Please select the document uploaded by you:",
        "type" : "button",
        "option" : [
            { "btn" : "Aadhar card", "isLink" : false, "keyword" : "Aadhar card" },
            { "btn" : "Passport", "isLink" : false, "keyword" : "Passport" },
            { "btn" : "Driving license", "isLink" : false, "keyword" : "Driving license" },
            { "btn" : "Voter ID", "isLink" : false, "keyword" : "Voter ID" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Payout mandate" : {
        "msg" : ["Please select the document uploaded by you:"],
        "utterance" : "Please select the document uploaded by you:",
        "type" : "button",
        "option" : [
            { "btn" : "Cancelled cheque", "isLink" : false, "keyword" : "Cancelled cheque" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Income document" : {
        "msg" : ["Please select the document uploaded by you:"],
        "utterance" : "Please select the document uploaded by you:",
        "type" : "button",
        "option" : [
            { "btn" : "Form 16", "isLink" : false, "keyword" : "Form 16" },
            { "btn" : "Salary slip (Last 3 months)", "isLink" : false, "keyword" : "Salary slip" },
            { "btn" : "Income tax return (Last 3 years)", "isLink" : false, "keyword" : "Income tax return" },
            { "btn" : "Bank statement (Last 3 months)", "isLink" : false, "keyword" : "Bank statement" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Photo" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "PAN card" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Aadhar card" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Passport" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Driving license" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Voter ID" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Cancelled cheque" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Form 16" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Salary slip" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Income tax return" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Bank statement" : {
        "msg" : ["Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: <b>OS12345678</b> or <b>OB12345678</b>"],
        "utterance" : "Thank you for uploading your document(s). Kindly share your alphanumeric application number only within 10 minutes to help us process your request. For example: OS12345678 or OB12345678",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Claim intimation" : {
        "msg" : ["Thank you for uploading Document. Kindly share policy number (8 digit) or mobile number (10 digit) only within 20 minutes to help us process your request."],
        "utterance" : "Thank you for uploading Document. Kindly share policy number (8 digit) or mobile number (10 digit) only within 20 minutes to help us process your request.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Additional claim related document" : {
        "msg" : ["Thank you for uploading Document. Kindly share policy number (8 digit) or mobile number (10 digit) only within 20 minutes to help us process your request."],
        "utterance" : "Thank you for uploading Document. Kindly share policy number (8 digit) or mobile number (10 digit) only within 20 minutes to help us process your request.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Update bank details" : {
        "msg" : ["Thanks you for uploading Document. Kindly share policy number (8 digit) only within 10 minutes to help us process your request."],
        "utterance" : "Thank you for uploading Document. Kindly share policy number (8 digit) or mobile number (10 digit) only within 20 minutes to help us process your request.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "OB12345678" : {
        "msg" : ["Thank you for uploading your document(s). Your request will be processed and we will send you a confirmation shortly."],
        "utterance" : "Thank you for uploading your documents. Your request will be processed and we will send you a confirmation shortly.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "To get a call for assistance" : {
        "msg" : ["Please help me with your mobile number (10 digit) to receive a call back for assistance."],
        "utterance" : "Please help me with your mobile number (10 digit) to receive a call back for assistance.",
        "type" : "input",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "9999999999" : {
        "msg" : ["Thank you for sharing your mobile number. Our claim specialist will be calling you shortly."],
        "utterance" : "Thank you for sharing your mobile number. Our claim specialist will be calling you shortly.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "feedback",
            "option" : []
        },
    },
    "Group insurance" : {
        "msg" : ["Surely! I can help you with below mentioned <b>Group Insurance Plans</b>,"],
        "utterance" : "Thank you for sharing your mobile number. Our claim specialist will be calling you shortly.",
        "type" : "button",
        "option" : [
            { "btn" : "SuperAnnutation", "isLink" : false, "keyword" : "SuperAnnutation" },
            { "btn" : "Group Annuity", "isLink" : false, "keyword" : "Group Annuity" },
            { "btn" : "Gratuity", "isLink" : false, "keyword" : "Gratuity" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "SuperAnnutation" : {
        "msg" : ["Alright! How may I help you with SuperAnnuation?"],
        "utterance" : "Alright! How may I help you with SuperAnnuation?",
        "type" : "button",
        "option" : [
            { "btn" : "Objective of Superannuation Scheme", "isLink" : false, "keyword" : "Objective of Superannuation Scheme" },
            { "btn" : "How does Superannuation work?", "isLink" : false, "keyword" : "How does Superannuation work" },
            { "btn" : "How can I access my account?", "isLink" : false, "keyword" : "How can I access my account" },
            { "btn" : "How much the member can withdraw?", "isLink" : false, "keyword" : "How much the member can withdraw" },
            { "btn" : "What is a DC scheme?", "isLink" : false, "keyword" : "What is a DC scheme" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Group Annuity" : {
        "msg" : ["How may i help you with Annuity."],
        "utterance" : "How may i help you with Annuity.",
        "type" : "button",
        "option" : [
            { "btn" : "What is annuity?", "isLink" : false, "keyword" : "What is annuity" },
            { "btn" : "Annuity Income Option", "isLink" : false, "keyword" : "Annuity Income Option" },
            { "btn" : "TDS Certificate not received", "isLink" : false, "keyword" : "TDS Certificate not received" },
            { "btn" : "How to start your lifelong income?", "isLink" : false, "keyword" : "How to start your lifelong income" },
            { "btn" : "Nomination", "isLink" : false, "keyword" : "Nomination" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Gratuity" : {
        "msg" : ["How may i help you with Gratuity."],
        "utterance" : "How may i help you with Gratuity.",
        "type" : "button",
        "option" : [
            { "btn" : "What is Gratuity?", "isLink" : false, "keyword" : "What is Gratuity" },
            { "btn" : "What is the amount payable as gratuity?", "isLink" : false, "keyword" : "What is the amount payable as gratuity" },
            { "btn" : "When is medical applicable?", "isLink" : false, "keyword" : "When is medical applicable" },
            { "btn" : "What salary is considered for calculating Gratuity?", "isLink" : false, "keyword" : "What salary is considered for calculating Gratuity" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Objective of Superannuation Scheme" : {
        "msg" : ["Superannuation scheme is a pension plan catering to your retirement needs, the objective is to accumulate funds for life after retirement which will help you to live:Dignified post retirement lifeProtect your spouse and dependents"],
        "utterance" : "Superannuation scheme is a pension plan catering to your retirement needs, the objective is to accumulate funds for life after retirement which will help you to live:Dignified post retirement lifeProtect your spouse and dependents",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "How does Superannuation work" : {
        "msg" : ["<b>This plan offers you two schemes - Defined Benefit and Defined Contribution</b>.Defined Benefit Superannuation scheme: The benefits payable to the employee on retirement are decided upfront. An employer pays the premiums for superannuation. The premiums are then invested by us and the wealth pool created under this plan is used to make claim payments on the employee exits. The accumulated wealth can also be used to purchase Annuity Plan that would provide periodic pay-outs for lifetimeDefined Contribution Superannuation scheme: A fixed amount or a pre-decided percentage of employee's salary is periodically paid as premiums towards their superannuation kitty. The premiums are then invested by us and accumulate upto the employee’s exit. The accumulated wealth is then used to purchase an Annuity Plan that would provide periodic pay-outs for lifetime"],
        "utterance" : "This plan offers you two schemes - Defined Benefit and Defined Contribution.Defined Benefit Superannuation scheme: The benefits payable to the employee on retirement are decided upfront. An employer pays the premiums for superannuation. The premiums are then invested by us and the wealth pool created under this plan is used to make claim payments on the employee exits. The accumulated wealth can also be used to purchase Annuity Plan that would provide periodic pay-outs for lifetimeDefined Contribution Superannuation scheme: A fixed amount or a pre-decided percentage of employee's salary is periodically paid as premiums towards their superannuation kitty. The premiums are then invested by us and accumulate upto the employee’s exit. The accumulated wealth is then used to purchase an Annuity Plan that would provide periodic pay-outs for lifetime",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "How can I access my account" : {
        "msg" : ["3 Simple steps to follow . <br/> Step I : Please select Login Type &gt; Login with Userid <br/>Step 2  Enter User ID - Userid can be your mobile number or email id <br/>Step 3. OTP based password generation. Enter the OTP that you will receive ( Mobile number and email id need to be registered with us ) <br/> Incase website access has not been provided by your trust, please write to mysuperannuation"],
        "utterance" : "3 Simple steps to follow . <br/> Step I : Please select Login Type &gt; Login with Userid <br/>Step 2  Enter User ID - Userid can be your mobile number or email id <br/>Step 3. OTP based password generation. Enter the OTP that you will receive ( Mobile number and email id need to be registered with us ) <br/> Incase website access has not been provided by your trust, please write to mysuperannuation",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "How much the member can withdraw" : {
        "msg" : ["At the time of resignation or retirement you can withdraw 1/3rd of the accumulated funds and 2/3rd  is utilized towards the Annuity purchase. Withdrawal of 1/3rd superannuation funds on resignation is subject to taxes. <br/>Tax will not be deducted on withdrawal at time of retirement or death of the member"],
        "utterance" : "At the time of resignation or retirement you can withdraw 1/3rd of the accumulated funds and 2/3rd  is utilized towards the Annuity purchase. Withdrawal of 1/3rd superannuation funds on resignation is subject to taxes. <br/>Tax will not be deducted on withdrawal at time of retirement or death of the member",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "What is a DC scheme" : {
        "msg" : ["A fixed amount or a pre-decided percentage of employee salary is periodically paid as premiums towards their superannuation kitty. The premiums are then invested by us and accumulate upto the employee exit. The accumulated wealth is then used to purchase an Annuity Plan that would provide periodic pay-outs for the lifetime"],
        "utterance" : "A fixed amount or a pre-decided percentage of employee salary is periodically paid as premiums towards their superannuation kitty. The premiums are then invested by us and accumulate upto the employee exit. The accumulated wealth is then used to purchase an Annuity Plan that would provide periodic pay-outs for the lifetime",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "What is annuity" : {
        "msg" : ["On maturity of your pension policy, your maturity amount will be used to give you pension income.   <a target='_blank' href='https://customer.iciciprulife.com'> Login to your online account </a> for annuity registration.  <br/>Click on 'Annuity Registration' under the 'Transactions' tab and proceed"],
        "utterance" : "On maturity of your pension policy, your maturity amount will be used to give you pension income. Login to your online account </a> for annuity registration. Click on 'Annuity Registration' under the 'Transactions' tab and proceed",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Annuity Income Option" : {
        "msg" : ["You have the following pension options available in your policy: <br/>1. Single Life without Return of Purchase price. <br/>2. Joint Life without Return of Purchase price.<br/>3. Single Life Return of Purchase price.<br/>4. Joint Life with Return of Purchase price.<br/>5. Single Life with Return of Purchase price at Age 80.<br/>6. Single Life with 50% Return of Purchase price at Age 80.<br/>7. Single Life with Return of Purchase price from Age 76.<br/>8. Single Life with Return of Purchase price on Critical illness (CI) or Permanent Disability due to accident (PD) or Death.<br/>9. Deferred Single Life with Return of Purchase price.<br/>10. Deferred Joint Life with Return of Purchase price.<br/>11. Deferred Single Life with Return of Purchase price on Critical illness (CI) or Permanent Disability due to accident (PD) or Death.<br/><a target='_blank' href='https://www.google.com'> Click here to read FAQs on pension (annuity) </a>"],
        "utterance" : "You have the following pension options available in your policy:1. Single Life without Return of Purchase price.2. Joint Life without Return of Purchase price.3. Single Life Return of Purchase price.4. Joint Life with Return of Purchase price.5. Single Life with Return of Purchase price at Age 80.6. Single Life with 50% Return of Purchase price at Age 80.7. Single Life with Return of Purchase price from Age 76.8. Single Life with Return of Purchase price on Critical illness (CI) or Permanent Disability due to accident (PD) or Death.9. Deferred Single Life with Return of Purchase price.10. Deferred Joint Life with Return of Purchase price.11. Deferred Single Life with Return of Purchase price on Critical illness (CI) or Permanent Disability due to accident (PD) or Death.Click here to read FAQs on pension (annuity)",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "TDS Certificate not received" : {
        "msg" : ["You can write to us on myannuity@iciciprulife.com from your registered email id. Do mention your policy number in the subject line <br/>You can also enquire about your query by calling up our customer care on 1860 266 7766 from Monday to Saturday, 10AM to 7PM . Please select option 3 from the main menu followed by 2"],
        "utterance" : "You can write to us on myannuity@iciciprulife.com from your registered email id. Do mention your policy number in the subject line. You can also enquire about your query by calling up our customer care on 1860 266 7766 from Monday to Saturday, 10AM to 7PM . Please select option 3 from the main menu followed by 2",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "How to start your lifelong income" : {
        "msg" : ["Many of our unit linked pension policies have a feature, called Annuity postponement that allow you to postpone your pension start date.  <br/><br/><a target='_blank' href='https://www.google.com'> Login to your online account </a> reset your pension (annuity) start date. <br/>1. Under the 'Transactions' tab, select 'Annuity Postponement.' <br/>2. On 'Annuity Postponement' page, select your preferred pension start date from the drop down and proceed.  <br/><br/><a target='_blank' href='https://www.google.com'> Click here to read FAQs on pension (annuity)</a>"],
        "utterance" : "Many of our unit linked pension policies have a feature, called Annuity postponement that allow you to postpone your pension start date.Login to your online account reset your pension (annuity) start date1. Under the 'Transactions' tab, select 'Annuity Postponement.2. On 'Annuity Postponement' page, select your preferred pension start date from the drop down and proceedClick here to read FAQs on pension (annuity)",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Nomination" : {
        "msg" : ["Nominee can be added or change. Please fill Nomination form and Provide KYC of nominee<br/>You can submit the documents through any of these options:<ul style='padding: 16px'><br/><li><b>Email us:</b> Scanned copy of duly filled form and documents to be mailed to myannuity@iciciprulife.com from your registered email id. Do mention your policy number in the subject line.<br/></li><li><b> Our Branch:</b> Submit the documents at any of our branches. To locate the nearest branch, click here. <a target='_blank' href='https://www.google.com'>Click Here</a> to locate a nearest ICICI Prudential branch.  By the way, there are a host of online services available for you, try logging in now!<br/> <a target='_blank' href='https://www.google.com'>Login to your online account</a> <br/></li><li><b> Courier:</b> Courier the form/ documents to mentioned addressGroup Annuity department, ICICI Prudential Life Insurance Co. Ltd.,Unit No. 1A &amp; 2A, Raheja Tipco Plaza, Rani Sati Marg, Malad (East), Mumbai- 400 097.</li></ul>"],
        "utterance" : "Here are the details",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "What is Gratuity" : {
        "msg" : ["Gratuity is a statutory obligation under Payment of Gratuity Act, 1972 to provide a lump sum payment to an employee when he retires or leaves the service."],
        "utterance" : "Gratuity is a statutory obligation under Payment of Gratuity Act, 1972 to provide a lump sum payment to an employee when he retires or leaves the service.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "What is the amount payable as gratuity" : {
        "msg" : ["Gratuity is payable @ 15 days last drawn ‘wages’ for every completed year of service or part thereof exceeding 6 months, with a cap of Rs 20,00,000. However, an employee can receive better terms under contract with employer."],
        "utterance" : "Gratuity is payable @ 15 days last drawn ‘wages’ for every completed year of service or part thereof exceeding 6 months, with a cap of Rs 20,00,000. However, an employee can receive better terms under contract with employer.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "When is medical applicable" : {
        "msg" : ["Sure! To track your medical test status now, simply <a target='_blank href='https://www.google.com'>Click Here</a> and enter your App no. and select the health check-up icon. Please keep your application number handy."],
        "utterance" : "Sure! To track your medical test status now, simply Click Here and enter your App no. and select the health check-up icon. Please keep your application number handy.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "What salary is considered for calculating Gratuity" : {
        "msg" : ["Wages shall consist of basic plus D.A, as per last drawn salary. However, allowances like bonus, commission, HRA, overtime etc. are not to be considered for calculations. In case of employees paid on monthly wages basis, per day wages should be calculated by dividing monthly salary by 26 days to arrive at daily wages."],
        "utterance" : "Wages shall consist of basic plus D.A, as per last drawn salary. However, allowances like bonus, commission, HRA, overtime etc. are not to be considered for calculations. In case of employees paid on monthly wages basis, per day wages should be calculated by dividing monthly salary by 26 days to arrive at daily wages.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "unable to understand query" : {
        "msg" : ["I am unable to understand your query. I am still learning. Can you please elaborate or select the service from the below or call us @ 1860 266 7766. If you an NRI customer, Please call us at +91 22 6193 0777."],
        "utterance" : "I am unable to understand your query. I am still learning. Can you please elaborate or select the service from the below or call us @ 1860 266 7766. If you an NRI customer, Please call us at +91 22 6193 0777.",
        "type" : "button",
        "option" : [
            { "btn" : "Track status", "isLink" : false, "keyword" : "Track new application" },
            { "btn" : "Policy details", "isLink" : false, "keyword" : "Policy details" },
            { "btn" : "Locate us", "isLink" : false, "keyword" : "Locate us" },
            { "btn" : "Pay premium", "isLink" : false, "keyword" : "Pay premium" },
            { "btn" : "Fund value", "isLink" : false, "keyword" : "Fund value" },
            { "btn" : "Statements", "isLink" : false, "keyword" : "Statements" },
            { "btn" : "Troubleshoot: Safari Browser", "isLink" : false, "keyword" : "Safari Browser" },
            { "btn" : "Chat with agent", "isLink" : false, "keyword" : "Agent_support" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "Safari Browser" : {
        "msg" : ["If you are using <b>Safari browser</b> and the digital assistant is unable to service you after providing mobile number/ policy number, then kindly follow the below steps. <br> <b>For Macbooks:</b> <br> 1. Go to Safari &gt;&gt; Preferences <br> 2. Click Privacy tab <br> 3. Uncheck <b>Prevent cross-site tracking</b> <br> 4. Restart the browser and start chatting <br> <b>For iPhones/ iPads:</b> <br> 1. Go to devices Settings  &gt;&gt; Safari <br> 2. In Safari, Under Privacy and Security &gt;&gt; uncheck <b>Prevent cross-site tracking</b> <br> 3. Refresh the browser and start chatting"],
        "utterance" : "If you are using Safari browser and the digital assistant is unable to service you after providing mobile number/ policy number, then kindly follow the below steps. For Macbooks: 1. Go to Safari Preferences 2. Click Privacy tab 3. Uncheck Prevent cross-site tracking 4. Restart the browser and start chatting For iPhones and iPads: 1. Go to devices Settings Safari 2. In Safari, Under Privacy and Security uncheck Prevent cross-site tracking 3. Refresh the browser and start chatting",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "pdr" : {
        "msg" : ["<b>Tap below</b> 👇🏻 to submit your <b>Health Declaration</b> online"],
        "utterance" : "Tap below to submit your Health Declaration online",
        "type" : "button",
        "option" : [
            { "btn" : "<a target='_blank' class='bot-options-link-btn' href='https://www.google.com'>Fill Online</a>", "isLink" : true, },
            
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "mobile app" : {
        "msg" : ["3 Quick steps to update contact details through our mobile app: <br>1. Download &amp; login to our app <br>2. Go to My Profile <br>3. Click on Edit  and update your details <br>And you’re done! To download the app now, <a target='_blank' href='https://www.google.com'>Click here</a>"],
        "utterance" : "Here is how can you update details",
        "type" : "button",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "icici pru life branch" : {
        "msg" : ["Update your contact details by visiting your nearest ICICI Prudential Life Insurance branch. To locate now, <a target='_blank' href='https://www.google.com'>Click here</a>"],
        "utterance" : "Here is how can you update details",
        "type" : "button",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "call center" : {
        "msg" : ["Update contact details through our call center.  You can call us on 1860 266 7766 from your registered mobile number. <br>Timings: 10:00 A.M. to 7:00 P.M., Monday to Saturday (except national holidays)"],
        "utterance" : "Here is how can you update details",
        "type" : "button",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "website" : {
        "msg" : ["3 Quick steps to update contact details through our website: <br>1.  Login to your account on  <a href='https://www.google.com' target='_blank'> www.google.com </a> <br>2. Go to My Profile <br>3. Click on Edit  and update your details <br>And you’re done! Visit our website today."],
        "utterance" : "Here is how can you update details",
        "type" : "button",
        "option" : [],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    },
    "88888888" : {
        "msg" : ["I can help you with :"],
        "utterance" : "I can help you with",
        "type" : "button",
        "option" : [
            {"btn" : "<a target='_blank' href='https://www.google.com' class='bot-options-link-btn'>To pay your premiums online now</a>", isLink: true, "keyword" : ""},
            { "btn" : "To get call for assistance", "isLink" : false, "keyword" : "To get call for assistance" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    }, 
    "To get call for assistance" : {
        "msg" : ["Hi , Thank you for sharing your contact details the response. Our customer service executive will be calling you shortly."],
        "utterance" : "Hi , Thank you for sharing your contact details the response. Our customer service executive will be calling you shortly.",
        "type" : "msg",
        "option" : [],
        "prompt" : {
            "type" : "feedback",
            "option" : []
        },
    }, 
    "confuse" : {
        "msg" : ["Sorry, I am unable to answer this query at the moment. Don’t worry, you can chat with our Service Executive or explore servicing options for further assistance."],
        "utterance" : "Sorry, I am unable to answer this query at the moment. Don’t worry, you can chat with our Service Executive or explore servicing options for further assistance",
        "type" : "button",
        "option" : [
            { "btn" : "Chat with sevice executive", "isLink" : false, "keyword" : "Agent_support" },
            { "btn" : "More servicing options", "isLink" : false, "keyword" : "More servicing options" },
        ],
        "prompt" : {
            "type" : "",
            "option" : []
        },
    }, 
}

export default data;
